var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPs = function SvgPs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-118 0h682.67v512H-118z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(110.63) scale(.9375)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-246 0H778.002v170.667H-246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-246 170.667H778.002v170.667H-246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "M-246 341.334H778.002v170.667H-246z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-246 512.001l512.001-256L-246 0v512.001z",
    fill: "red"
  })))));
};
export default __webpack_public_path__ + "assets/22be50deca0f4dfe5c1e8c6b8de331f0.svg";
export { SvgPs as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/ps.svg